var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"close-img",attrs:{"src":_vm.closeImage,"alt":""},on:{"click":_vm.goBack}})]),_c('iframe',{staticClass:"user-agreement",attrs:{"src":_vm.url,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }